var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    isCurrentLast
  } = options;

__p+='\n\n';
/* Template for rendering 'next' chevron in pagination

    isCurrentLast: if currently shown page is the last one

 */
__p+='\n<span class="next">\n    '+
((__t=( isCurrentLast ? '' : '<a class="next" data-omtag = "srp:paging:next">'))==null?'':__t)+
'<span></span><i class=\'ra ra-chevron-right\'></i>'+
((__t=( isCurrentLast? '' : '</a>'))==null?'':__t)+
'\n</span>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/pagination/next_page.jst.ejs